import { Alert, AlertDescription } from '@/components/ui/alert';
import { Shield } from 'lucide-react';
import { useAgeRestrictions } from '@/hooks/useAgeRestrictions';

export function MinorAccountBanner() {
  const { isMinor, canMakePublic, loading } = useAgeRestrictions();

  if (loading || !isMinor) return null;

  return (
    <Alert className="bg-secondary/10 border-secondary mb-4">
      <Shield className="h-4 w-4" />
      <AlertDescription className="text-sm">
        <span className="font-medium">🦖 Your account is private for your safety.</span>
        {canMakePublic ? (
          <> You can now choose to make it public in your settings!</>
        ) : (
          <> You'll be able to make it public when you turn 16.</>
        )}
      </AlertDescription>
    </Alert>
  );
}
